<template>
<div>
    <Breadcrumbs main="Admin" submain="Complaints" title="মতামত (Remarks)" />
    <div>
        <div class="container-fluid" v-if="role === 'admin'">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <b-row class="d-flex justify-content-center align-items-center">
                                <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="onchol || ward_no || start_date || end_date">
                                        <feather type="x"></feather>
                                        <h7>Clear All</h7>
                                    </div>
                                </b-col>

                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div class="row mt-2">
                                <div class="col-md-3">
                                    <h7>অঞ্চল</h7>
                                    <b-form-select v-model="onchol" :options="formattedOnchols" @change="onOncholChange" placeholder="Select a Ward"></b-form-select>
                                </div>
                                <div class="col-md-3">
                                    <h7>ওয়ার্ড নং</h7>
                                    <b-form-select v-model="ward_no" :options="formattedWards" placeholder="Select a Ward"></b-form-select>
                                </div>
                                <div class="col-md-3">
                                    <div>
                                        <h7>শুরুর তারিখ</h7>
                                        <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div>
                                        <h7>শেষ তারিখ</h7>
                                        <datepicker placeholder="Select a Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue mt-4">
                                    <b-table show-empty stacked="md" :items="complain_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>

                                        <template #cell(name)="row">
                                            <div v-if="row.item.name" style="max-width: 250px;">
                                                <p>{{ row.item.name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(phone)="row">
                                            <div v-if="row.item.phone">
                                                <p>{{ row.item.phone }}</p>
                                            </div>
                                        </template>

                                        <!-- <template #cell(status)="row">
                                                <span
                                                    v-if="row.item.status"
                                                    :class="statusClasses[row.item.status]"
                                                    class="status-pill"
                                                    v-b-modal.modal-prevent-closing-priority
                                                    @click="getStatus(row.item.status, row.item.tracking_id)"
                                                >
                                                    {{ getStatusLabel(row.item.status) }}
                                                </span>
                                            </template> -->

                                        <template #cell(description)="row">
                                            <div v-if="row.item.description" style="max-width: 400px;">
                                                <p>{{ row.item.description.slice(0, 100) }}</p>
                                            </div>
                                        </template>

                                        <template #cell(action)="row">
                                            <!-- <span style="display: flex; gap: 12px;"> -->
                                            <!-- <div>
                                                        <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteComplain(row.item.id)" title="Delete"></feather>
                                                    </div> -->
                                            <div @click="viewContact(row.item)" style="margin-left: 11px;">
                                                <feather type="eye" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="অভিযোগ দেখুন" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                            <!-- </span> -->
                                        </template>
                                    </b-table>
                                </div>
                            </div>

                            <div v-else>
                                <loader />
                            </div>

                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid mt-4" v-else>
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div style="height: calc(100vh - 200px); text-align: center; padding: 80px 20px;">
                            <h5>Welcome to Fair Dhaka Admin Dashboard</h5>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
    </div>

    <!-- View Complain Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="মতামত দেখুন" size="lg">
        <div style="display: flex; flex-direction: column; gap: 16px;" id="section">
            <!-- <div style="display: flex; flex-direction: row;">
                    <div style="width: 210px; font-weight: 600;">ট্র্যাকিং আইডি (Tracking Id)</div> <div>{{ complain.tracking_id }} </div>
                </div> -->
            <div class="no-print d-flex justify-content-end">
                <div @click="printPdf('section')">
                    <b-button variant="success">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <feather type="printer" size="18px"></feather>
                            <h7>Print</h7>
                        </div>
                    </b-button>
                </div>
            </div>
            <div style="display: flex; flex-direction: row;">
                <div style="width: 210px; font-weight: 600;">নাম (Name)</div> {{ complain.name }}
            </div>
            <div style="display: flex; flex-direction: row;">
                <div style="width: 210px; font-weight: 600;">ফোন নং (Phone No)</div> {{ complain.phone }}
            </div>
            <div style="display: flex; flex-direction: row;">
                <div style="width: 210px; font-weight: 600;">অবস্থান (Location)</div> {{ complain.location }}
            </div>
            <div style="display: flex; flex-direction: row;">
                <div style="width: 210px; font-weight: 600;">ওয়ার্ড নং (Ward No)</div>
                <div v-if="complain.ward_no">{{ complain.ward_no.bangla_name }} ({{ complain.ward_no.name }})</div>
            </div>
            <!-- <div style="display: flex; flex-direction: row;">
                    <div style="width: 210px; font-weight: 600;">সমস্যার ধরন (Issue Type)</div> {{ complain.issue_type }} 
                </div>
                <div style="display: flex; flex-direction: row; align-items: center;">
                    <div style="width: 210px; font-weight: 600;">অবস্থা (Status)</div> 
                    <div>
                        <span
                            v-if="complain.status"
                            :class="statusClasses[complain.status]"
                            class="status-pill"
                        >
                            {{ getStatusLabel(complain.status) }}
                        </span>
                    </div>
                </div> -->
            <div style="display: flex; flex-direction: column; gap: 4px;">
                <div style="width: 210px; font-weight: 600;">বিস্তারিত (Details)</div>
                <div>{{ complain.description }} </div>
            </div>
            <!-- <div v-if="complain.picture">
                    <div style="width: 210px; font-weight: 600;">ছবি (Image)</div>
                    <img style="max-width: 100%;" :src="host + complain.picture" alt="">
                </div> -->
        </div>
    </b-modal>

    <!-- Update Status -->
    <b-modal id="modal-prevent-closing-priority" ref="modal" title="অভিযোগের অবস্থা আপডেট করুন" @show="resetModal" @hidden="resetModal" @ok="handlePriorityOk">
        <form ref="form" @submit.stop.prevent="updateStatus">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="statuses"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Complaint Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this remark?</div>
    </b-modal>
</div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    mapState
} from 'vuex';
import loader from './loader/loader.vue';
import Datepicker from 'vuejs-datepicker';
import moment from "moment";

export default {
    components: {
        loader,
        Datepicker
    },

    data() {
        return {
            role: '',
            host: 'https://api.fairdhaka.com',
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'নাম',
                    sortable: true
                },
                {
                    key: 'phone',
                    label: 'ফোন নং',
                    sortable: true
                },
                {
                    key: 'location',
                    label: 'অবস্থান',
                    sortable: true
                },
                {
                    key: 'ward_no.bangla_name',
                    label: 'ওয়ার্ড নং',
                    sortable: true
                },
                {
                    key: 'description',
                    label: 'বিস্তারিত',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'দেখুন',
                    sortable: false
                }
            ],
            onchol: null,
            ward_no: null,
            start_date: null,
            end_date: null,
            complain: {}, // view complaint modal
            selectedStatus: '',
            update_tracking_id: '',
            delete_value: null,
            statuses: [{
                    value: 'pending',
                    text: 'Pending'
                },
                {
                    value: 'acknowledged',
                    text: 'Acknowledged'
                },
                {
                    value: 'in_progress',
                    text: 'In Progress'
                },
                {
                    value: 'resolved',
                    text: 'Resolved'
                },
                {
                    value: 'rejected',
                    text: 'Rejected'
                },
            ],
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            wards: state => state.issue.wards,
            onchols: state => state.issue.onchols,
            complain_list: state => state.issue.complain_list,
            loading: state => state.contact.contactLoading,
            error: state => state.contact.contactError
        }),

        statusClasses() {
            return {
                pending: 'status-pending',
                acknowledged: 'status-acknowledged',
                in_progress: 'status-in-progress',
                resolved: 'status-resolved',
                rejected: 'status-rejected'
            };
        },

        formattedWards() {
            return this.wards.map(ward => {
                return {
                    value: ward ?.id,
                    text: `${ward?.bangla_name} (${ward?.name})`
                };
            });
        },

        formattedOnchols() {
            return this.onchols.map(onchol => {
                return {
                    value: onchol ?.id,
                    text: `${onchol?.bangla_name} (${onchol?.name})`
                };
            });
        }
    },

    watch: {
        '$route.params.id': 'onIdChange',

        complain_list(newVal, oldVal) {
            this.items = newVal;
            this.totalRows = newVal.length;
            this.currentPage = 1;
        },

        onchol() {
            this.updateQuery();
        },
        ward_no() {
            this.updateQuery();
        },
        start_date() {
            this.updateQuery();
        },
        end_date() {
            this.updateQuery();
        }
    },

    mounted() {
        this.role = localStorage.getItem("role");
        this.$store.dispatch('issue/getWards')
        this.$store.dispatch('issue/getOnchols')
        this.initializeComplaints();
    },

    methods: {
        printPdf(section) {
            this.downloadPdf = true;

            const printContents = document.getElementById(section).innerHTML;
            const originalContents = document.body.innerHTML;
            const wrappedPrintContents = `<div class="page" style="margin: 80px;">${printContents}</div>`;

            document.body.innerHTML = wrappedPrintContents;

            window.print();

            document.body.innerHTML = originalContents;

            location.reload();
        },
        getStatus(status, id) {
            this.update_tracking_id = id
            this.selectedStatus = status
        },

        resetModal() {
            this.ticket.subject = null
            this.ticket.refer_to = null
        },

        handlePriorityOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.updateStatus()
        },

        updateStatus() {
            this.$store.dispatch("issue/updateComplainStatus", {
                id: this.update_tracking_id,
                update_status: this.selectedStatus,
                category: 'remarks'
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "সফল হয়েছে!",
                        text: 'স্ট্যাটাস সফলভাবে আপডেট হয়েছে',
                        icon: "success"
                    });
                    this.update_tracking_id = ''
                    this.selectedStatus = ''
                } else {
                    Swal.fire({
                        title: "ভুল হয়েছে!",
                        text: 'স্ট্যাটাস সফলভাবে আপডেট হয়নি',
                        icon: "error"
                    });
                }
            })
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-priority')
            })
        },

        initializeComplaints() {
            const {
                ward_no,
                onchol,
                start_date,
                end_date
            } = this.$route.query;

            if (ward_no || onchol || start_date || end_date) {
                this.onchol = onchol || null;
                this.ward_no = ward_no || null;
                this.start_date = start_date || null;
                this.end_date = end_date || null;

                this.fetchFilteredComplaints();
            } else {
                this.$store.dispatch("issue/filterComplaints", {
                    category: 'remarks'
                }).then((response) => {
                    this.complain_list = response.data;
                    this.totalRows = this.complain_list.length;
                }).catch(error => {
                    console.error("Failed to fetch complaints:", error);
                });
            }
        },

        onOncholChange() {
            this.$store.dispatch('issue/getWardsByOnchol', this.onchol)
        },

        updateQuery() {
            const query = {};

            if (this.onchol) query.onchol = this.onchol;
            if (this.ward_no) query.ward_no = this.ward_no;
            if (this.start_date) query.start_date = this.formatDate(this.start_date);
            if (this.end_date) query.end_date = this.formatDate(this.end_date);

            // Update the route without reloading the page
            this.$router.replace({
                path: this.$route.path,
                query
            });

            this.fetchFilteredComplaints();
        },

        formatDate(date) {
            if (!date) return null;
            const d = new Date(date);
            const month = `${d.getMonth() + 1}`.padStart(2, '0');
            const day = `${d.getDate()}`.padStart(2, '0');
            return `${d.getFullYear()}-${month}-${day}`;
        },

        fetchFilteredComplaints() {
            this.$store.dispatch("issue/filterComplaints", {
                category: 'remarks',
                ward_no: this.$route.query.ward_no,
                onchol: this.$route.query.onchol,
                start_date: this.$route.query.start_date,
                end_date: this.$route.query.end_date
            }).then(() => {
                this.items = this.complain_list;
                this.totalRows = this.complain_list.length;
            }).catch(error => {
                console.error("Failed to fetch complaints:", error);
            });
        },

        viewContact(data) {
            this.complain = data;
        },

        clearFilter() {
            this.onchol = null;
            this.ward_no = null;
            this.start_date = null;
            this.end_date = null;

            this.$nextTick(() => {
                this.$router.replace({
                    path: `/admin/remarks`,
                    query: {}
                });
            });
        },

        onIdChange(newId, oldId) {
            this.$store.dispatch("issue/filterComplaints", {
                category: 'remarks'
            }).then((response) => {
                // console.log(response.data)
                this.complain_list = response.data;
            });
        },

        getStatusLabel(status) {
            const found = this.complain_list.find(item => item.status === status);
            return found ? found.status : status.replace('_', ' ');
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("contact/addContact", {
                contact: this.contact
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.message,
                        icon: "success"
                    });
                    this.contact.name = null
                    this.contact.phone = null
                    this.contact.contact_type = null
                    this.contact.shelter = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.message,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        deleteComplain(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("issue/deleteComplain", {
                delete: this.delete_value,
                category: 'remarks'
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.message,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.message,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>

<style scoped>
.status-pill {
    padding: 2px 8px;
    border-radius: 9999px;
    color: white;
    font-size: 0.875rem;
    /* text-sm */
    text-transform: capitalize;
    display: inline-block;
}

/* Define colors manually */
.status-pending {
    background-color: #facc15;
    /* Yellow */
}

.status-acknowledged {
    background-color: #3b82f6;
    /* Blue */
}

.status-in-progress {
    background-color: #8b5cf6;
    /* Purple */
}

.status-resolved {
    background-color: #22c55e;
    /* Green */
}

.status-rejected {
    background-color: #ef4444;
    /* Red */
}

@media print {

    .no-print {
        display: none !important;
    }
}
</style>
